import { proStudioUrqlGql as urqlGql } from '@pypestream/api-services';

/**
 * Returns the environment names a bot is currently published to (lowercased,
 * e.g. `['sandbox', 'live']`), derived from `getEnvBotVersions.data.envs` — an
 * env→deployed-version map where a truthy version means the bot is published in
 * that env. Returns `[]` when the bot is not published in any environment.
 */
export const getBotPublishedEnvs = async ({
  botId,
  projectId,
}: {
  botId: string;
  projectId: string;
}): Promise<string[]> => {
  const response = await urqlGql.getBotData({ botId, projectId });
  const envs = (response.data?.getEnvBotVersions?.data?.envs ?? {}) as Record<
    string,
    string | null | undefined
  >;

  return Object.entries(envs)
    .filter(([, version]) => Boolean(version))
    .map(([env]) => env.toLowerCase());
};
